import React, { useState, useRef } from "react";
import { api, getErrorMessage } from "@/lib/api";
import { useLocale } from "@/context/LocaleContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";

export default function Newsletter({ variant = "section" }) {
  const { t } = useLocale();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const pending = useRef(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pending.current) return;
    if (!consent) {
      toast.error(t("newsletter.consent_error"));
      return;
    }
    setLoading(true);
    pending.current = true;
    try {
      const res = await api.post("/newsletter/subscribe", { email, consent, source: variant });
      toast.success(res.data.message);
      setEmail("");
      setConsent(false);
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setLoading(false);
      pending.current = false;
    }
  };

  return (
    <form onSubmit={submit} className="w-full max-w-md mx-auto" data-testid="newsletter-form">
      <div className="flex flex-col sm:flex-row gap-2 mb-3">
        <Input
          type="email"
          required
          autoComplete="email"
          aria-label={t("newsletter.email_placeholder")}
          disabled={loading}
          placeholder={t("newsletter.email_placeholder")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="newsletter-email-input"
          className="bg-levami-creme border-levami-sable"
        />
        <Button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit-button"
          className="bg-levami-charbon text-levami-creme hover:bg-levami-brun whitespace-nowrap"
        >
          {loading ? t("newsletter.submitting") : t("newsletter.submit")}
        </Button>
      </div>
      <label className="flex items-start gap-2 text-xs text-levami-brun/70 leading-relaxed">
        <Checkbox checked={consent} disabled={loading} onCheckedChange={setConsent} data-testid="newsletter-consent-checkbox" className="mt-0.5" />
        <span>
          {t("newsletter.consent_prefix")}{" "}
          <a href="/confidentialite" className="underline hover:text-levami-primary">{t("newsletter.consent_link")}</a>.
        </span>
      </label>
    </form>
  );
}
